'use strict';

require('../core/core');
require('../../modules/forms/forms');
require('../../modules/pagination/pagination');

require('../../models/user/userQualification');
require('../../models/user/userAchievements');

require('../../models/camp/campCountry');
require('../../models/camp/campRegion');
require('../../helpers/striptags-filter/striptags.filter');
require('angular-resource');
require('angular-sanitize');

angular.module('far.search', [
    'ui.bootstrap',
	'far.core',
    'dekky.forms',
    'dekky.pagination',

    'far.models.userQualification',
    'far.models.userAchievements',

    'far.models.campCountry',
    'far.models.campRegion',
    'templates',
    'far.helpers.stripTagsFilter',
    'far.helpers.rawFilter',
    'ngResource',
    'ngSanitize'
])
.value('formsConfig', {
    theme: '/dekky.forms/themes/far'
});
